import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';
import { calculateSetScenarios } from '../utils';

function SetScenariosChart({ player1, player2, probability, isGrandSlam }) {
  const scenarios = calculateSetScenarios(probability / 100, isGrandSlam);

  const data = scenarios.map(s => ({
    scenario: s.scenario,
    probabilité: Math.round(s.probability),
    joueur: s.winner === 1 ? player1 : player2
  }));

  return (
    <div style={{marginTop: 20}}>
      <h5 style={{fontSize: 15, marginBottom: 10}}>
        Probabilité des scénarios de sets {isGrandSlam ? "(Grand Chelem)" : "(Format standard)"}
      </h5>
      <div style={{height: 300}}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="scenario" />
            <YAxis domain={[0, 50]} />
            <Tooltip
              formatter={(value, name) => [`${value}%`, 'Probabilité']}
              labelFormatter={(value) => `Score: ${value}`}
            />
            <Legend />
            <Bar dataKey="probabilité" fill="#8884d8" radius={[10, 10, 0, 0]}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={entry.joueur === player1 ? "#8884d8" : "#82ca9d"}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div style={{display: "flex", justifyContent: "space-between", marginTop: 5, fontSize: 14}}>
        <div>
          <span style={{display: 'inline-block', width: 12, height: 12, backgroundColor: '#8884d8', marginRight: 5}}></span>
          {player1}
        </div>
        <div>
          <span style={{display: 'inline-block', width: 12, height: 12, backgroundColor: '#82ca9d', marginRight: 5}}></span>
          {player2}
        </div>
      </div>
    </div>
  );
}

export default SetScenariosChart; 